<template>
  <div class="container">
    <h1 class="py-4">マスターデータ</h1>
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="l-pid">契約番号</label><br />
          <input v-model="contract" placeholder="契約番号" class="input-boot" />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">代表契約番号</label><br />
          <input
            v-model="contractrep"
            placeholder="代表契約番号"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">電話番号</label><br />
          <input
            v-model="telephone"
            placeholder="電話番号"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">携帯電話番号</label><br />
          <input
            v-model="mobile"
            placeholder="携帯電話番号"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">カナ英字氏名</label><br />
          <input v-model="name" placeholder="カナ英字氏名" class="input-boot" />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">漢字氏名</label><br />
          <input
            v-model="kanjiname"
            placeholder="漢字氏名"
            class="input-boot"
          />
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-primary mr10" @click="clear">クリア</button>
        <button class="btn btn-primary" @click="search">検索</button>
      </div>
      <div class="form-row">
        <div class="form-group col-md-auto">
          <input type="file" id="csvUpload" hidden />
          <button disabled class="btn btn-primary">
            CSV インポート
          </button>
        </div>
        <div class="form-group col-md-auto">
          <vue-json-to-csv
            :labels="this.csvCurrentFields"
            :json-data="this.csvData"
            :csv-title="this.fileName"
          >
            <button class="btn btn-success">
              CSV ダウンロード
            </button>
          </vue-json-to-csv>
        </div>
      </div>
    </div>
    <div :key="key">
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="dataTable"
          :items="tableData"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <template #cell(契約番号)="data">
            <router-link
              :to="{
                name: 'ContractDetails',
                query: { contractId: data.item.契約番号 },
              }"
              target="_blank"
              >{{ data.item.契約番号 }}</router-link
            >
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="dataTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";
import VueJsonToCsv from "vue-json-to-csv";
import prefs from "@/constants/PrefsEnum";
import countries from "@/constants/CountriesEnum";

export default {
  name: "MasterData",
  mixins: [utils, master, prefs, countries],
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  watch: {
    /*     currentPage(value) {
      sessionStorage.currentPage = value;
    }, */
  },
  data() {
    return {
      csvCurrentFields: {},
      currentPage: 1,
      perPage: 10,
      fileName: "",
      labels: [],
      loading: true,
      tableData: [],
      csvData: [],
      db: firebase.firestore(),
      name: "",
      kanjiname: "",
      contract: "",
      contractrep: "",
      mobile: "",
      telephone: "",
      key: 0,
    };
  },
  components: {
    VueJsonToCsv,
  },
  created: function() {
    this.loadCollection();
  },
  methods: {
    orderByContractNumber(a, b) {
      if (a.契約番号 > b.契約番号) {
        return 1;
      } else if (a.契約番号 < b.契約番号) {
        return -1;
      }
      return 0;
    },
    init() {
      this.tableData = [];
      this.csvData = [];
      this.key = this.key ? 0 : 1;
    },
    clear() {
      this.contract = "";
      this.contractrep = "";
      this.mobile = "";
      this.telephone = "";
      this.name = "";
      this.kanjiname = "";
      this.loadCollection();
    },
    search() {
      let searchParams = {
        contract_number: this.contract,
        representative_contract_number: this.contractrep,
        mobile: this.mobile,
        telephone: this.telephone,
        kanji_name: this.kanjiname,
        kana_name: this.name,
      };
      this.loadCollection(searchParams);
    },
    loadCollection(searchParams = null) {
      this.init();
      this.loading = true;

      let query = this.db.collection("master");
      if (searchParams !== null) {
        for (const [key, value] of Object.entries(searchParams)) {
          if (value !== "") {
            query = query.where(key, "==", value);
          }
        }
      }
      query.orderBy("contract_number", "asc");
      this.fileName = this.tsvFormat.masterData.fileName;
      this.csvCurrentFields = this.tsvFormat.masterData.labels;
      query
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.exists) {
              var data = doc.data();
              this.tableData.push({
                契約番号: data.contract_number,
                代表契約番号: data.representative_contract_number,
                電話番号: data.telephone,
                携帯電話番号: data.mobile,
                カナ英字氏名: data.kana_name.trim(),
                漢字氏名: data.kanji_name.trim(),
                契約日: data.contract_date,
                更新日: data.contract_update_day,
              });
              this.csvData.push(data);
            }
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>
